import { useTranslation } from 'react-i18next';
import { FaCheckCircle } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import {
  LinkButton,
  Modal,
  SectionLayout,
  Typography,
} from '@breezeai-frontend/cargo-ui';

import { useUser } from '../../../context/auth/auth-hooks';
import { usePlatform } from '../../../context/PlatformContext';
import { useTracking } from '../../../utils/snowplow/hooks';
import { ActiveOpenCoverTooltip } from '../../components/ActiveOpenCoverTooltip/ActiveOpenCoverTooltip';
import { CertificatesTable } from './CertificatesTable/CertificatesTable';

export const CertificatesPage = () => {
  useTracking();
  const { platform } = usePlatform();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const isCanceled = searchParams.get('cancelled') === 'true';

  const user = useUser();
  const { isWtw } = usePlatform();
  const isAuthorized = Boolean(user?.permissions.certificates?.view);
  const isAuthorizedToCreateCertificate = Boolean(
    user?.permissions.certificates?.create,
  );

  return (
    <SectionLayout
      isAuthorized={isAuthorized}
      title={t('table.Title', {
        ns: 'certificates',
        context: platform,
      })}
      tooltip={
        isWtw
          ? {
              trigger: <ActiveOpenCoverTooltip.Trigger />,
              content: <ActiveOpenCoverTooltip.Content />,
            }
          : undefined
      }
      data-testid="certificates-page"
      actions={
        isAuthorizedToCreateCertificate && (
          <LinkButton
            size="small"
            data-testid="get-certificate-button"
            href="/certificates/create"
            width="auto"
            label={t('table.GetACertificate', {
              ns: 'certificates',
              context: platform,
            })}
          />
        )
      }
    >
      <CertificatesTable />
      <Modal
        showExitButton
        isDismissable
        isOpen={isCanceled}
        className="max-w-xl"
        onExit={() => {
          setSearchParams((prev) => {
            prev.delete('cancelled');
            return prev;
          });
        }}
        heading={
          <div className="flex flex-col items-center py-3 space-y-3">
            <FaCheckCircle size={42} className="fill-system-green-500" />
            <Typography level="h2" customStyles="text-center">
              Your certificate has been successfully cancelled!
            </Typography>
          </div>
        }
      />
    </SectionLayout>
  );
};
